export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  let token = "";
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      token = c.substring(name.length, c.length);
    }
  }
  return token;
}

// setting SameSite to Strict for now
// may need to adjust if other needs arise
export function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = `${name}=${encodeURI(value) || ""}${expires}"; path=/;SameSite=Strict`;
}

export function removeCookie(cName) {
  const encodedValue = encodeURI(getCookie(cName));
  let date = new Date();
  date.setTime(date.getTime());
  let formatNow = date.toUTCString();

  document.cookie = `${cName}=${encodedValue}; expires=${formatNow}; path=/;SameSite=Strict`;
}
